import { useQuery } from "@apollo/client/react";
import { AreasDocument } from "@repo/graphql/documents/address/query.generated";
import { useMemo } from "react";

// Comfortably above the largest top-level division count of any country.
export const REGIONS_LIMIT = 500;

/** Top-level areas (regions, departments, provinces, states...) of a country. */
export default function useRegions(countryCode: string | null | undefined) {
  const { data, loading } = useQuery(AreasDocument, {
    variables: {
      countryCode: countryCode ?? "",
      depth: 1,
      limit: REGIONS_LIMIT,
    },
    skip: !countryCode,
  });
  const regions = useMemo(() => data?.address.areas ?? [], [data]);
  return { regions, loading };
}
